module.exports = __webpack_public_path__ + "static/media/avatarteam.a2a4718e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatarteam.svg
// module id = 1311
// module chunks = 0